import { Typography } from "@cpj-ai/panel-npm-package";
import React from "react";

interface TitleProps {
  title: string;
  Icon: React.FC<any>;
}

const Title: React.FC<TitleProps> = ({ Icon, title }) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Icon height={24} width={24} fill="black" />
        <Typography className="font-semibold text-lg">{title}</Typography>
      </div>
    </div>
  );
};

export default Title;
